import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MbsSize, ModalService } from 'mbs-ui-kit';
import { PaymentMethodsModalComponent } from 'mbs-ui-shared@components/payment-methods-modal/payment-methods-modal.component';
import { ApplicationStateFacade } from 'mbs-ui-shared@facades/application.facade';
import { LicensesSignalFacade } from 'mbs-ui-shared@facades/licenses-signal.facade';
import { UiStorageKey } from 'mbs-ui-shared@models';
import { catchError, noop, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService {
  private licensesSignalFacade = inject(LicensesSignalFacade);
  private modalService = inject(ModalService);
  private applicationStateFacade = inject(ApplicationStateFacade);

  private uiStorage = toSignal(this.applicationStateFacade.getUiStorage());
  private hidePaymentMethodModal = computed(() => this.uiStorage()?.[UiStorageKey.HidePaymentMethodModal] === 'true');

  public open(url: string): void {
    !this.licensesSignalFacade.isPostPayment() || this.hidePaymentMethodModal() ? this.redirect(url) : this.showHint(url);
  }

  private showHint(url: string): void {
    this.applicationStateFacade
      .updateStorageSetting(UiStorageKey.HidePaymentMethodModal, 'true')
      .pipe(catchError(() => of(null)))
      .subscribe();

    this.modalService.openCustom(PaymentMethodsModalComponent, { size: MbsSize.sm }).then(() => this.redirect(url), noop);
  }

  private redirect(url: string): void {
    window.open(url, '_blank');
  }
}
